import React from "react";
import footerImg from "../assets/images/Footer-img.png";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
import bg_home from "../assets/images/bg-img-home1.png";
import logo from "../assets/images/6.png";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import EmailIcon from "@mui/icons-material/Email";
import HeadphonesIcon from "@mui/icons-material/Headphones";
import SendIcon from "@mui/icons-material/Send";
import FacebookOutlinedIcon from "@mui/icons-material/FacebookOutlined";
import InstagramIcon from "@mui/icons-material/Instagram";
import XIcon from "@mui/icons-material/X";
const Footer = () => {
  return (
    <div
      className="flex flex-col justify-center items-center xl:mt-40 lg:mt-8  relative"
      style={{
        backgroundImage: "linear-gradient(to bottom, white 30%, #0f2349 30%)",
      }}
    >
      {/* For Footer Banner  */}

      <div className="2xl:w-[70%] 3xl:w-3/5 xl:w-4/5 w-[95%] relative flex lg:flex-row flex-col-reverse justify-between items-center lg:items-start  bg-[#243FFA] rounded-lg ">
        <div className="absolute bottom-0 right-4 w-52 lg:block hidden">
          <img src={bg_home} alt="bg_home" className="" />
        </div>
        <div className="lg:w-[48%] w-4/5 ">
          <div className="lg:absolute xl:-top-[185px] xl:-left-20 -top-12 lg:-left-10 flex items-center justify-center lg:justify-start lg:items-start ">
            <img
              className="xl:w-auto xl:h-auto lg:w-[400px] w-[500px]"
              src={footerImg}
              alt="footer-png"
            />{" "}
          </div>
        </div>
        <div className="lg:w-[52%] w-4/5 pt-[75px] pb-[35px] text-center lg:text-left">
          <h3 className="text-white text-[16px] font-outfit font-normal">
            GET IN TOUCH
          </h3>
          <p className="pb-7 my-2 text-white md:text-[44px] text-3xl font-outfit font-medium leading-[1.1em]">
            Provide The Best Medical Service for You!
          </p>
          <div className="my-1 w-full  text-center sm:text-left">
            <a
              href="1"
              className="text-white font-outfit text-xl hover:text-black flex justify-center sm:justify-start font-bold items-center group "
            >
              Book An Appointment{" "}
              <span className="text-sm ml-6 group-hover:bg-white border-[1px] border-white rounded-full p-5  flex justify-center items-center xl:w-16 w-12 h-12 xl:h-16 text-white transition-all hover:duration-200 group-hover:text-black">
                <ArrowOutwardIcon className="text-sm" />
              </span>
            </a>
          </div>
        </div>
      </div>

      {/* Footer Content  */}

      <div className=" 2xl:w-[70%] 3xl:w-3/5 xl:w-4/5 mt-10 sm:w-[95%] w-4/5 mb-11 h-auto flex flex-row flex-wrap lg:flex-nowrap pb-12">
        <div className="lg:w-[31%] sm:w-1/2 w-full lg:mr-2.5 pr-7 mb-8">
          <div>
            <img src={logo} alt="logo" />
          </div>
          <p className="text-[#D4DFFB] text-[16px] font-outfit mt-6 font-light">
            Quis autem vel eum iure reprehenderit rui in ea voluptate velit esse
            quam nihil moles illum rui dolorem eum fugiat…
          </p>
          <p className="text-[#D4DFFB] text-[16px] font-outfit mt-6 font-light">
            Suscipit laboriosam, nisi ut aliruid commo nostrum veniam…
          </p>
        </div>
        <div className="lg:w-[17%] sm:w-1/2 w-full ">
          <h3 className="text-white text-2xl font-outfit pt-4 font-medium mb-4">
            Our Services
          </h3>
          <ul>
            <li className="my-2">
              <a
                href="/"
                className="text-[#D4DFFB] text-[16px] font-light font-outfit hover:text-[#007bff]  transition-all hover:duration-200"
              >
                <NavigateNextIcon /> Cardiology
              </a>
            </li>
            <li className="my-2">
              <a
                href="/"
                className="text-[#D4DFFB] text-[16px] font-light font-outfit hover:text-[#007bff]  transition-all hover:duration-200"
              >
                <NavigateNextIcon /> Pulmonary
              </a>
            </li>
            <li className="my-2">
              <a
                href="/"
                className="text-[#D4DFFB] text-[16px] font-light font-outfit hover:text-[#007bff]  transition-all hover:duration-200"
              >
                <NavigateNextIcon /> Gynecology
              </a>
            </li>
            <li className="my-2">
              <a
                href="/"
                className="text-[#D4DFFB] text-[16px] font-light font-outfit hover:text-[#007bff]  transition-all hover:duration-200"
              >
                <NavigateNextIcon /> Opthalmology
              </a>
            </li>
            <li className="my-2">
              <a
                href="/"
                className="text-[#D4DFFB] text-[16px] font-light font-outfit hover:text-[#007bff]  transition-all hover:duration-200"
              >
                <NavigateNextIcon /> Psychiatry
              </a>
            </li>
          </ul>
        </div>
        <div className="lg:w-[29%] sm:w-1/2 w-full ">
          <h3 className="text-white text-2xl font-outfit pt-4 font-medium mb-4">
            Contact
          </h3>
          <ul>
            <li className="text-[#D4DFFB] text-[16px] font-light font-outfit hover:text-[#007bff]  transition-all hover:duration-200 flex flex-row gap-2">
              <span>
                <LocationOnIcon />{" "}
              </span>{" "}
              8-3-224/B/5, Yousufguda Main Rd. Hyderabad, Telangana 500045
              <span></span>
            </li>
            <li className="text-[#D4DFFB] text-[16px] my-3 font-light font-outfit ">
              <a
                className="flex flex-row gap-2.5 hover:text-[#007bff]  transition-all hover:duration-200 "
                href="mailto:info@gmail.com"
              >
                <EmailIcon /> info@email.com
              </a>
            </li>
            <li className="text-[#D4DFFB] text-[16px] my-3 font-light font-outfit ">
              <a
                className="flex flex-row gap-2.5 hover:text-[#007bff]  transition-all hover:duration-200 "
                href="tel:4455661122"
              >
                <HeadphonesIcon /> +91 9999 999 999
              </a>
            </li>
            <li className="text-[#D4DFFB] text-[16px] my-3 font-light font-outfit ">
              <a
                className="flex flex-row gap-2.5 hover:text-[#007bff]  transition-all hover:duration-200 "
                href="tel:4455661122"
              >
                <HeadphonesIcon className="invisible" /> +91 9999 999 999
              </a>
            </li>
          </ul>
        </div>
        <div className="lg:w-[23%] sm:w-1/2 w-full ">
          <h3 className="text-white text-2xl font-outfit pt-4 font-medium mb-4">
            Subscribe to Newsletter
          </h3>

          <form className="relative mb-3">
            <input
              type="email"
              placeholder="Enter your Eamil Address:"
              className="w-full bg-transparent placeholder:text-[#a2b1cc] text-sm border-b-[1px] outline-none text-[#a2b1cc] border-[#a2b1cc] py-2 px-1"
            />
            <button aria-labelledby="submit button" className="absolute top-0 text-[#007bff]  -rotate-45 right-1 hover:text-white transition-all hover:duration-200 border-none outline-none ">
              <SendIcon className="text-[26px]" fontSize="20px" />
            </button>
          </form>
          <div className="flex justify-start items-center mt-8 gap-4">
            <a
              href="/" aria-label="facebok"
              className="w-11 h-11 rounded-full bg-[#243FFA] flex justify-center items-center text-white hover:-translate-y-1 transition-all hover:duration-500"
            >
              <FacebookOutlinedIcon />
            </a>
            <a aria-label="instagram"
              href="/"
              className="w-11 h-11 rounded-full bg-[#243FFA] flex justify-center items-center text-white hover:-translate-y-1 transition-all hover:duration-500"
            >
              <InstagramIcon />
            </a>
            <a
              href="/" aria-label="xicon"
              className="w-11 h-11 rounded-full bg-[#243FFA] flex justify-center items-center text-white hover:-translate-y-1 transition-all hover:duration-500"
            >
              <XIcon />
            </a>
          </div>
        </div>
      </div>
      <div className="bg-[#0d1f42] w-full text-center text-[#e7edfa] font-medium text-sm py-4">
        <a href="https:novatales.com">Copyright © NovaTales 2025. All rights reserved</a>
      </div>
    </div>
  );
};

export default Footer;
